import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslationService } from '@i18n/translation.service';
import { setTheme } from 'ngx-bootstrap/utils';
import { locale as jpLang } from './i18n/languages/jp';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'web-client';
  constructor(private translationService: TranslationService) {
    const body = document.getElementsByTagName('body')[0];

    if (body) {
      body.classList.add('theme-main');
    }
    setTheme('bs5');
    this.translationService.loadTranslations(jpLang);
  }
}
